//
//
//
//
//
//
//
//
//
//
//
//

import Header from '../components/layout/Header.vue';
import Footer from '../components/layout/Footer.vue';
import Courier from '~/components/Courier';

export default {
  head() {
    return {
      title: '江苏省技术产权交易市场-专利技术转让-专利交易发布-知识产权申请平台',
      meta: [
        {
          hid: 'keywords',
          name: 'keywords',
          content: '专利转让,技术转让,专利交易,知识产权,知识产权申请,江苏省技术产权交易市场',
        },
        {
          hid: 'description',
          name: 'description',
          content:
            '江苏省技术产权交易市场平台，专注专利转让、技术转让、专利交易、知识产权、知识产权申请，包括发明技术成果、实用新型专利、知识产权服务、电子信息、生物与新医药、航空航天、新材料、高技术服务、新能源与节能资源与环境、先进制造与自动化等服务。',
        },
      ],
    };
  },
  middleware: 'appData',
  components: {
    Courier,
    Header,
    Footer,
  },
  data() {
    return {
      showRightWidow: true,
      navigationType: '',
      headerType: '',
      footerType: '',
    };
  },
  mounted() {
    if (
      this.$router.currentRoute.path.includes('/achievement') ||
      this.$router.currentRoute.path.includes('/Intermediary') ||
      this.$router.currentRoute.path.includes('/demandDashboard/dashboard') ||
      this.$router.currentRoute.path.includes('/demandDashboard') ||
      this.$router.currentRoute.path.includes('/roadShow') ||
      this.$router.currentRoute.path.includes('/overall') ||
      this.$router.currentRoute.path.includes('/lasa')
    ) {
      this.showRightWidow = false;
    }
  },
  methods: {},
};
